import { Alignments, classFromProperties, getOptionalProps } from '../../ui-helpers';
import './main-content.css';

/**
 * Layout main content component.
 * @param {ReactDOM.props} props Component properties.
 * @returns Row component.
 */
 const MainContent = (props) => {

    // Excluded properties for automatic properties propagation
    const Excluded = [].concat(Alignments);

    // Generate component
    return (
        <div 
            className={classFromProperties(props, 'main-content', Alignments)}
            {...getOptionalProps(props, Excluded)}
        >
            {props.children}
        </div>
    );
}
export default MainContent;